import { ConvertPriceToString } from '../../../Helpers/CustomConverter'
import { useAuth } from '../../../Providers/AuthProvider'

const OfferRequestSideBar = ({ handleSendOfferRequest, basketItems, handleSendOfferFomPH, handleDeleteSavedOffer, cartTotalNet, cartTotalGross, cartTotalTax, requestOfferNo }) => {
    const { authState } = useAuth()

    //const totalNetValue = basketItems.reduce((acc, item) => acc + (isNaN(item.costNet) ? 0 : item.costNet) * (isNaN(item.qty) ? 0 : item.qty), 0)
    //const totalGrossValue = basketItems.reduce((acc, item) => acc + (isNaN(item.costGross) ? 0 : item.costGross) * (isNaN(item.qty) ? 0 : item.qty), 0)

    let buttonDeleteText = authState.user && authState.user.isOperator ? 'Anuluj ofertę' : 'Anuluj zapytanie ofertowe'

    if (!basketItems || basketItems.length === 0) {
        return null
    }
    return (<div className='ps-3 pe-3' style={{ fontSize: '16px' }}>
        <div className="row">
            <div className="col-6">
                <span>Suma netto</span>
            </div>
            <div className="col-6 text-end">
                {/* <span>{ConvertPriceToString(totalNetValue)}</span> */}
                <span>{ConvertPriceToString(cartTotalNet)}</span>
            </div>
        </div>
        <div className="row mt-3 basket-page-underline">
            <div className="col-6">
                <span>{`VAT`}</span>
            </div>
            <div className="col-6 mb-4 text-end">
                {/* <span>{ConvertPriceToString(totalGrossValue - totalNetValue)}</span> */}
                <span>{ConvertPriceToString(cartTotalTax)}</span>
            </div>
        </div>
        <div className="row mt-3">
            <div className="col-6">
                <b>Suma brutto</b>
            </div>
            <div className="col-6 text-end">
                {/* <b>{ConvertPriceToString(totalGrossValue)}</b> */}
                <span>{ConvertPriceToString(cartTotalGross)}</span>
            </div>
        </div>
        <div className="row mt-4">
            {authState.user && authState.user.isOperator ?
                (<button className='btn-app-primary' onClick={handleSendOfferFomPH}>{requestOfferNo && requestOfferNo != 'null' ? 'Edytuj ofertę dla klienta' : 'Utwórz ofertę dla klienta'}</button>)
                :
                (<button className='btn-app-primary' onClick={handleSendOfferRequest}>Złóż zapytanie ofertowe</button>)}
        </div>
        <div className="row">
            <button className='btn-app-secondary mt-3' onClick={handleDeleteSavedOffer}>{buttonDeleteText}</button>
        </div>
    </div>)
}

export default OfferRequestSideBar